import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import messages from './messages';

import Switch from 'components/forms/Switch';
import CloseIcon from './components/CloseIcon';
import HeaderContainer from './components/HeaderContainer';

const Title = styled.h1`
    display: inline;
    margin: 0;
    font-size: 20px;
    font-weight: bold;
    color: ${({ theme }) => theme.text};
`;

const NonGuaranteedContainer = styled.div`
    display: flex;
    align-items: flex-end;

    & > *:first-child {
        margin-right: 5px;
    }
`;

export const Header = ({ title, closeView, showNonGuaranteed, toggleNonGuaranteedDisplay }) => {
    const intl = useIntl();
    return (
        <HeaderContainer>
            <Title>{title}</Title>
            <NonGuaranteedContainer>
                <Switch size="small" onChange={toggleNonGuaranteedDisplay} checked={showNonGuaranteed} />
                <FormattedMessage {...messages.header.showNonGuaranteed} />
            </NonGuaranteedContainer>
            <CloseIcon onClick={closeView} title={intl.formatMessage(messages.header.closeButtonTooltip)} />
        </HeaderContainer>
    );
};

export default Header;
